import { List, Record } from "immutable";

import { TicketApprovalEntityApproverModel } from "./TicketApprovalEntityApproverModel";
import { TicketApprovalRequestModel } from "./TicketApprovalRequestModel";

export type TTicketApprovalEntityType =
  | "Automatic"
  | "DirectManager"
  | "DirectoryGroup"
  | "HR"
  | "IntegrationMaintainer"
  | "IntegrationOwner"
  | "OnCallIntegrationSchedule"
  | "ResourceMaintainer"
  | "ResourceOwner"
  | "SlackChannel"
  | "TeamMember"
  | "TeamsChannel"
  | "User"
  | "Webhook";

const defaults = {
  approvers: List<TicketApprovalEntityApproverModel>(),
  displayName: "",
  id: "",
  identifier: null as null | string,
  request: null as null | TicketApprovalRequestModel,
  ticketApprovalRequestId: "",
  type: "" as TTicketApprovalEntityType,
};

export class TicketApprovalEntityModel extends Record<typeof defaults>(defaults) {
  get approverIds(): List<string> {
    return this.approvers.flatMap((approver) => approver.userIds);
  }

  static fromServerData(data: unknown): TicketApprovalEntityModel {
    const { approvers, displayName, id, identifier, request, ticketApprovalRequestId, type } = data as typeof defaults;

    return new TicketApprovalEntityModel({
      approvers: approvers
        ? List(approvers.map((approver) => TicketApprovalEntityApproverModel.fromServerData(approver)))
        : List(),
      displayName,
      id,
      identifier,
      request: request ? TicketApprovalRequestModel.fromServerData(request) : null,
      ticketApprovalRequestId,
      type,
    });
  }
}
